// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"20878435","300":"df753219","467":"20878435","664":"763166b5","740":"20878435","841":"20878435","919":"20878435","990":"20878435"}[chunkId] + ".chunk.css";
};